import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
	Button,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Grid,
	Divider,
	colors,
	TextField
} from '@mui/material';

import DateTimePicker from 'components/DatePicker/DateTimePicker.js';
import { SelectField } from 'components';

import { enqueueSnackbar } from 'actions';

import { GenerateReport } from '../../../../../../actions/ReportsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(1),
	},

	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const Report4G16h = (props) => {
	const { className, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.session.user);

	const [startTime, setStartTime] = useState(moment());
	const [endTime, setEndTime] = useState(moment());
	const [controllers, setControllers] = useState();
	const [filterType, setFilterType] = useState('UF');
	const [vendor, setVendor] = useState('Huawei');

	const _handleControllersChange = (event) => {
		setControllers(event.target.value);
	};

	const _handleStartTimeChange = (value) => {
		setStartTime(value);
	};

	const _handleEndStartTimeChange = (value) => {
		setEndTime(value);
	};

	const _handleFilterTypeChange = (event) => {
		setFilterType(event.target.value);
	};

	const _handleVendorChange = (event) => {
		setVendor(event.target.value);
	};

	const _generate = () => {
		if (endTime.diff(startTime, 'hours') > 24) {
			dispatch(enqueueSnackbar({ message: 'Difference between dates cannot be superior to 24H', options: { variant: 'warning' } }));
			return;
		}

		if (startTime > endTime) {
			dispatch(enqueueSnackbar({ message: "StartTime can't be greater than EndTime", options: { variant: 'warning' } }));
			return;
		}

		const username = `${user.firstname} ${user.lastname}`;

		const filters = {
			startTime: startTime.utc(true).format(),
			endTime: endTime.utc(true).format(),
			filterType,
			controllers,
			vendor,
			reportType: 'Report4g16h',
			userId: user.id,
			username
		};

		dispatch(GenerateReport(filters));
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader title="Report 4G 16h" />
			<Divider />
			<CardContent>
				<Grid container spacing={2}>
					<Grid item md={2} xs={12}>
						<DateTimePicker label="Start Time" value={startTime} onChange={_handleStartTimeChange} />
					</Grid>
					<Grid item md={2} xs={12}>
						<DateTimePicker label="End Time" value={endTime} onChange={_handleEndStartTimeChange} />
					</Grid>
					<Grid item md={2} xs={12}>
						<SelectField
							id="vendor"
							name="vendor"
							value={vendor}
							onChange={_handleVendorChange}
							hintText="Vendor"
							menuItems={[{ value: 'Huawei', text: 'Huawei' }, { value: 'Ericsson', text: 'Ericsson' }]}
						/>
					</Grid>
					<Grid item md={2} xs={12}>
						<SelectField
							id="type"
							name="type"
							value={filterType}
							onChange={_handleFilterTypeChange}
							hintText="Filter Type"
							menuItems={[{ value: 'UF', text: 'UF' }, { value: 'NE_NAME', text: 'NE Name' }]}
						/>
					</Grid>
					<Grid item md={4} xs={12}>
						<TextField
							fullWidth
							label={filterType === 'UF' ? 'UFs' : 'NE Names'}
							helperText={filterType === 'UF' ? 'Example: UF 1,UF 2,UF 3' : 'Example: NE Name 1,NE Name 2,NE Name 3'}
							name="controllers"
							onChange={_handleControllersChange}
							value={controllers}
							variant="outlined"
						/>
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Button className={classes.generate} onClick={_generate} variant="contained">Generate</Button>
			</CardActions>
		</Card>
	);
};

Report4G16h.propTypes = {
	className: PropTypes.string
};

export default Report4G16h;
